var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasActualPipeline)?_c('ci-main-status',{attrs:{"size":2,"show-title":false,"only-icon":true,"status":_vm.actualPipeline.status,"icon-size":5}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }